import { render, staticRenderFns } from "./pushadd.vue?vue&type=template&id=21255300&scoped=true"
import script from "./pushadd.vue?vue&type=script&lang=js"
export * from "./pushadd.vue?vue&type=script&lang=js"
import style0 from "./pushadd.vue?vue&type=style&index=0&id=21255300&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21255300",
  null
  
)

export default component.exports